export const ACCOUNT_MANAGERS = gql`
    query AccountManagers {
        accountManagers {
            id
            firstName
            lastName
            email
        }
    }
`;
